import { Box, Link, Typography, useMediaQuery, useTheme } from "@mui/material";
import { DiscoverViewContext } from "contexts/DiscoverView";
import { useContext } from "react";
import { CustomEvent } from "schemas/functions";

import { formatNumber } from "utils/string";
import { trackEvent } from "utils/tracking";

import { BrandCardSource } from "../Results/schema";

interface Props {
  website?: string;
  instagramUsername?: string;
  instagramFollowerCount?: number;
  bentoBrandId?: number;
  source?: BrandCardSource;
}
const styles = {
  followerCount: {
    fontSize: 12,
  },
  instagramUsername: {
    width: "max-content",
    fontSize: 12,
    fontWeight: 500,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
};

const BrandSocialLinks = ({
  website,
  instagramUsername,
  instagramFollowerCount,
  bentoBrandId,
  source,
}: Props) => {
  const theme = useTheme();
  const { discoverTab } = useContext(DiscoverViewContext);

  const isXLScreen = useMediaQuery("(min-width:2000px)");
  const isLargeScreen = useMediaQuery("(min-width:1550px)");
  const isMediumLargeScreen = useMediaQuery(
    "(min-width:1301px) and (max-width:1550px)",
  );
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("sm"));
  let wrapLength =
    isMobileScreen || source === BrandCardSource.SIMILAR_BRANDS ? 15 : 50;
  if (source === BrandCardSource.DISCOVER_BRAND) {
    if (discoverTab !== null) {
      if (isXLScreen) {
        wrapLength = 20;
      } else if (isLargeScreen) {
        wrapLength = 10;
      } else if (isMediumLargeScreen) {
        wrapLength = 30;
      } else if (isMediumScreen) {
        wrapLength = 7;
      }
    } else {
      if (isXLScreen) {
        wrapLength = 32;
      } else if (isLargeScreen) {
        wrapLength = 15;
      } else if (isMediumLargeScreen) {
        wrapLength = 14;
      } else if (isMobileScreen) {
        wrapLength = 10;
      } else if (isMediumScreen) {
        wrapLength = 14;
      } else {
        wrapLength = 16;
      }
    }
  }

  const shortenedWebsite = website?.split("/")[0] || "";

  return (
    <Box>
      {(instagramUsername || website) && (
        <Typography sx={styles.instagramUsername} component="div">
          {instagramFollowerCount && (
            <Typography
              component="span"
              color="textSecondary"
              sx={styles.followerCount}
            >
              {formatNumber(instagramFollowerCount)} followers{" "}
            </Typography>
          )}
          {instagramUsername && (
            <Link
              target="_blank"
              href={`https://instagram.com/${instagramUsername}`}
              sx={{ width: "max-content" }}
              onClick={(e: CustomEvent) => {
                e.stopPropagation();
                trackEvent("Instagram Link Brand Card Clicked", {
                  "Instagram Username": instagramUsername,
                  "Bento Brand ID": bentoBrandId,
                });
              }}
            >
              @
              {instagramUsername?.length > wrapLength
                ? `${instagramUsername.substring(0, wrapLength)}...`
                : instagramUsername}
            </Link>
          )}
          {!isMobileScreen && website && (
            <>
              {instagramUsername && " | "}
              <Link
                target="_blank"
                href={`https://${website}`}
                sx={{ width: "max-content" }}
                onClick={(e: CustomEvent) => {
                  e.stopPropagation();
                  trackEvent("Website Brand Card Clicked", {
                    Website: website,
                    "Bento Brand ID": bentoBrandId,
                  });
                }}
              >
                {shortenedWebsite?.length > wrapLength
                  ? `${shortenedWebsite.substring(0, wrapLength)}...`
                  : shortenedWebsite}
              </Link>
            </>
          )}
        </Typography>
      )}
    </Box>
  );
};

export default BrandSocialLinks;
